import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';

class TimeOfDayFilter extends Component {
  doTimeOfDayChange(value) {
    if (this.props.filter !== value && typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  }

  render() {
    const sessions = this.props.sessions || [];
    if (sessions.length > 0) {
      const timesOfDay = [
        {
          value: 'all',
          label: 'Any time',
        },
        {
          value: 'morning',
          label: 'Morning',
        },
        {
          value: 'afternoon',
          label: 'Afternoon',
        },
        {
          value: 'evening',
          label: 'Evening',
        },
      ];

      return (
        <Filter
          id="TimeOfDay"
          defaultCaption="Any time"
          value={this.props.filter}
          onChange={(value) => this.doTimeOfDayChange(value)}
          options={timesOfDay}
        />
      );
    }
    return '';
  }
}

TimeOfDayFilter.propTypes = {
  onChange: PropTypes.func,
  sessions: PropTypes.array,
  filter: PropTypes.string,
};

export default TimeOfDayFilter;
